import React from 'react';
import { MailIcon, PhoneIcon, MapPinIcon, GlobeIcon, LinkedinIcon, GithubIcon } from 'lucide-react';
import cvData from '../../data/cv';
/** Editorial masthead: oversized serif name, kicker, contacts and stats. */
export function Masthead() {
  const {
    profile,
    stats,
    meta,
    experience
  } = cvData;
  const firstYear = experience.flatMap(e => e.period.match(/\d{4}/g) ?? []).map(Number).sort((a, b) => a - b)[0];
  const years = firstYear ? new Date().getFullYear() - firstYear : 10;
  const [first, ...rest] = profile.name.split(' ');
  const last = rest.join(' ');
  return <header className="relative" data-id="element-119" data-mp="24tufjdymi7dt">
      {/* top meta rail */}
      <div className="flex items-center justify-between border-b border-[var(--line-strong)] pb-3 font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--ink-faint)]" data-id="element-120" data-mp="24s9m5ro1ouhj">
        <span data-id="element-121" data-mp="ahxjf7p8kdcf">{meta.documentLabel}</span>
        <span className="tnum" data-id="element-122" data-mp="fewb7jlfg87g">{`≈ ${years} yrs · ${meta.homeCity}`}</span>
      </div>

      <div className="pt-8" data-id="element-123" data-mp="si0z7ndft9bt">
        <p className="font-mono text-[11px] uppercase tracking-[0.4em] text-[var(--accent)]" data-id="element-124" data-mp="siar5gi1lqk5">
          {meta.kicker}
        </p>

        {/* name + contacts share the row so the wide right space is used */}
        <div className="mt-4 flex items-start justify-between gap-8" data-id="element-125" data-mp="it9bxsjbnd78">
          <h1 className="font-display display-tight text-[76px] font-light leading-[0.9] text-[var(--ink)]" data-id="element-126" data-mp="dtek9mrq2jl4">
            {first}
            {last && <>
                <br data-id="element-127" data-mp="1besnycbr0gn9" />
                <span className="italic" data-id="element-128" data-mp="16i1zb0lvocq8">{last}</span>
              </>}
          </h1>

          <address className="shrink-0 space-y-1.5 pt-1 not-italic font-mono text-[11px] text-[var(--ink-soft)]" data-id="element-129" data-mp="11ifmgs9yoyhy">
            <a href={`mailto:${profile.email}`} className="flex items-center gap-2 hover:text-[var(--accent)]" data-id="element-130" data-mp="xhnd7z13atlo">
              <MailIcon className="h-3.5 w-3.5 text-[var(--accent)]" aria-hidden="true" data-id="element-131" data-mp="3m6twd25hh6hy" />
              {profile.email}
            </a>
            <a href={`tel:${profile.phone.replace(/\s/g, '')}`} className="flex items-center gap-2 tnum hover:text-[var(--accent)]" data-id="element-132" data-mp="3jp1nv4fgou9h">
              <PhoneIcon className="h-3.5 w-3.5 text-[var(--accent)]" aria-hidden="true" data-id="element-133" data-mp="39r42coozlbkk" />
              {profile.phone}
            </a>
            {profile.website && <a href={`https://${profile.website}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[var(--accent)]" data-id="element-134" data-mp="30x8wfeg1jh3v">
                <GlobeIcon className="h-3.5 w-3.5 text-[var(--accent)]" aria-hidden="true" data-id="element-135" data-mp="2qxqet4nls7ez" />
                {profile.website}
              </a>}
            {profile.linkedin && <a href={`https://${profile.linkedin}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[var(--accent)]" data-id="element-136" data-mp="2m0zx6cw5h3rg">
                <LinkedinIcon className="h-3.5 w-3.5 text-[var(--accent)]" aria-hidden="true" data-id="element-137" data-mp="1yexqjp18ye3i" />
                {profile.linkedin.replace('linkedin.com/in/', '')}
              </a>}
            {profile.github && <a href={`https://${profile.github}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[var(--accent)]" data-id="element-138" data-mp="2maa6xp0quwrs">
                <GithubIcon className="h-3.5 w-3.5 text-[var(--accent)]" aria-hidden="true" data-id="element-139" data-mp="2v2uan3vw7rjh" />
                {profile.github.replace('github.com/', '')}
              </a>}
            <span className="flex items-center gap-2 text-[var(--ink-faint)]" data-id="element-140" data-mp="302yqcroz8i8n">
              <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-141" data-mp="300vptdq776po" />
              {profile.location}
            </span>
          </address>
        </div>

        {/* headline stats */}
        <dl className="mt-7 grid grid-cols-4 gap-6 border-t border-[var(--line)] pt-5" data-id="element-142" data-mp="3o4br75vw8mlf">
          {stats.map(s => <div key={s.label} data-id="element-143" data-mp="1qu0qe919oe3">
              <dt className="sr-only" data-id="element-144" data-mp="1psereqhbhhl">{s.label}</dt>
              <dd className="font-display text-[30px] font-light leading-none text-[var(--ink)]" data-id="element-145" data-mp="1soe97hz6e85">
                {s.value}
              </dd>
              <p className="mt-2 font-mono text-[9px] uppercase tracking-[0.16em] text-[var(--ink-faint)]" data-id="element-146" data-mp="356sjc5l69a0l">
                {s.label}
              </p>
            </div>)}
        </dl>
      </div>
    </header>;
}